// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-inventory-stock/edit-inventory-stock.less
// module id = 4120
// module chunks = 0